export const setTransactions = (result: any) => {
  return {
    type: "SET_TRANSACTIONS",
    payload: result,
  }
}

export const setSelectedTransaction = (result: any) => {
  return {
    type: "SET_SELECTED_TRANSACTION",
    payload: result,
  }
}

export const removeSelectedTransaction = () => {
  return {
    type: "REMOVE_SELECTED_TRANSACTION",
    payload: {},
  }
}
